<template>
  <div>
    <div class="text-xl font-bold text-text leading-tight mb-8">{{ $t('listTitle') }}</div>
    
    <!-- Table view -->
    <div v-if="list.length > 0" class="overflow-hidden rounded-lg">
      <table class="min-w-full divide-y divide-border">
        <thead class="bg-gray-50">
          <tr>
            <th class="px-6 py-3 text-left text-base font-medium text-gray-500 uppercase tracking-wider">
            </th>
            <th class="px-6 py-3 text-left text-base font-medium text-gray-500 uppercase tracking-wider">
              {{ $t('table.usage') }}
            </th>
            <th v-if="!currentUserIsWatcher" class="px-3 py-3 text-center text-base font-medium text-gray-500 uppercase tracking-wider w-24">
              {{ $t('table.actions') }}
            </th>
          </tr>
        </thead>
        <tbody class="bg-white divide-y divide-border">
          <TagListItem v-for="item in list" :key="item.id"
                       :tag="item"
                       :allow-actions="!currentUserIsWatcher"
                       :table-mode="true"/>
        </tbody>
      </table>
    </div>
    
    <!-- Empty state -->
    <div v-else class="text-md pl-2 text-text">
      {{ $t('noTags') }}
    </div>
  </div>
</template>

<script>
import IconEdit from "@/components/icons/IconEdit";
import {mapGetters} from "vuex";
import IconTrash from "@/components/icons/IconTrash";
import TagListItem from "@/components/cabinet/SpaceSettings/TagsSettings/TagListItem";

export default {
  name: "TagsList",
  components: {TagListItem, IconTrash, IconEdit},
  props: {
    list: {
      type: Array
    }
  },
  computed: {
    ...mapGetters('space', ['currentUserIsWatcher']),
  },
  i18n: {
    messages: {
      en: {
        listTitle: 'Tags list',
        noTags: 'List is empty',
        table: {
          tag: 'Tag',
          usage: 'Count',
          actions: 'Actions'
        }
      },
      ru: {
        listTitle: 'Список тегов',
        noTags: 'Список пуст',
        table: {
          tag: 'Тег',
          usage: 'Кол-во',
          actions: 'Действия'
        }
      }
    }
  }
}
</script>
